import React, { useEffect, useState } from "react";
import { getAll } from "../api/API";

export default function RolesList() {
  const [users, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchUsers() {
      try {
        const data = await getAll("/custom/users");
        setRoles(data.docs || []);
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchUsers();
  }, []);

  if (loading) return <p>Loading users...</p>;

  return (
    <div>
      <h2>Users</h2>
      <ul>
        {users.map((user) => (
          <li key={user.id}>
            <strong>
              {user.firstName} {user.lastName}
            </strong>{" "}
            — {user.role?.description || "No description"}
          </li>
        ))}
      </ul>
    </div>
  );
}
